import ApiClient from "../helpers/ApiClient";

const getDocumentosMensais = (cnpj, params) =>
  ApiClient.apiClientDef.get(`empresa/${cnpj}/documentosMensais`, { params });

const postDocumentosMensais = (cnpj, data) =>
  ApiClient.apiClientDef.post(`empresa/${cnpj}/documentosMensais`, data);

const putDocumentosMensais = (cnpj, data) =>
  ApiClient.apiClientDef.put(`empresa/${cnpj}/documentosMensais`, data);

const verificarPeriodo = (cnpj, params) =>
  ApiClient.apiClientDef.get(`empresa/${cnpj}/documentosMensais/periodo`, {
    params,
  });

const postPeriodoPersonalizado = (cnpj, data) =>
  ApiClient.apiClientDef.post(
    `empresa/${cnpj}/documentosMensais/periodo`,
    data
  );

const getDocumentosAdicionais = (cnpj, params) =>
  ApiClient.apiClientDef.get(`empresa/${cnpj}/documentosMensais/adicionais`, {
    params,
  });

const postDocumentosAdicionais = (cnpj, data) =>
  ApiClient.apiClientDef.post(
    `empresa/${cnpj}/documentosMensais/adicionais`,
    data
  );

const deleteDocumentosAdicionais = (cnpj, params) =>
  ApiClient.apiClientDef.delete(
    `empresa/${cnpj}/documentosMensais/adicionais`,
    {
      params,
    }
  );

const DocumentosApiClient = {
  getDocumentosMensais,
  postDocumentosMensais,
  putDocumentosMensais,
  verificarPeriodo,
  postPeriodoPersonalizado,
  getDocumentosAdicionais,
  postDocumentosAdicionais,
  deleteDocumentosAdicionais,
};
export default DocumentosApiClient;
